import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const axis = { fontSize: 11, fontFamily: "ui-monospace, monospace", fill: "#6b7280" };

/** One bar chart, used for both the dispatch trend and publisher-wise pending stock. */
export const SimpleBar = ({ data, xKey, barKey, color = "#0055FF", testid, height = 240 }) => {
  if (!data?.length) return <div className="empty-state" data-testid={`${testid}-empty`}>No data yet.</div>;
  return (
    <div data-testid={testid} style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
          <CartesianGrid strokeDasharray="2 4" stroke="#e5e7eb" vertical={false} />
          <XAxis dataKey={xKey} tick={axis} interval={0} angle={data.length > 6 ? -25 : 0}
            textAnchor={data.length > 6 ? "end" : "middle"} height={data.length > 6 ? 62 : 28} />
          <YAxis tick={axis} allowDecimals={false} width={40} />
          <Tooltip contentStyle={{ fontSize: 12, borderRadius: 2 }} />
          <Bar dataKey={barKey} fill={color} radius={[2, 2, 0, 0]} maxBarSize={46} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
